import authAxios from '@services/authAxios';
import { useDownloadFile } from '@hooks/useDownloadFile';

export const TEMPLATE_TYPE = {
    DEFAULT: 'default',
    EMPTY: 'empty',
};

const fileNameMapper = (templateType) => {
    let fileName = '';
    switch (templateType) {
        case 'empty':
            fileName = 'Template Kosong.xlsx';
            break;

        default:
            fileName = 'Template Berisi Produk.xlsx';
            break;
    }
    return fileName;
};

const fetchDownloadTemplate = async (type = TEMPLATE_TYPE.DEFAULT) => {
    const { data } = await authAxios({
        url: `/api/v1/sellout/${type}-template`,
        method: 'GET',
        responseType: 'blob',
    });
    return data;
};

export const useDownloadTemplate = () => {
    return useDownloadFile({
        fetcher: ({ templateType }) => fetchDownloadTemplate(templateType),
        getFileName: ({ templateType }) => fileNameMapper(templateType),
    });
};
